export default {
  brand: 'Laplace',
  badge: 'Request a demo',
  title: 'Contact Laplace',
  intro:
    "To prepare for our demo call, please share a bit about yourself and the challenges you're hoping to address with Laplace.",
  partnerNote:
    'If you’re looking to sell implementation services based on Laplace or partner with us, please contact us here.',

  firstName: 'First Name',
  lastName: 'Last Name',
  workEmail: 'Work Email',
  workEmailPlaceholder: 'you@company.com',
  phone: 'Phone Number',
  phonePlaceholder: '+1 (555) 000-0000',
  language: "Language you'd like to use",
  languagePlaceholder: 'Select language',
  langRussian: 'Russian',
  langEnglish: 'English',
  region: 'Headquarters Region',
  regionPlaceholder: 'Select region',
  headcount: 'Company Headcount',
  headcountPlaceholder: 'Select headcount',
  useCase: 'How do you want to use Laplace?',
  useCasePlaceholder:
    'Tell us about your team, your knowledge sources, and the problems you want to solve.',

  consent:
    'I consent to receive marketing communications from Laplace about products, services, and events.',
  privacyNoticePrefix:
    'By submitting this form, you consent to Laplace processing your personal data to respond to your contact request. Laplace uses your contact information to communicate with you about our products and services. You may unsubscribe at any time. Please review our ',
  privacyPolicyLink: 'Privacy Policy',
  privacyNoticeSuffix: ' to learn about our privacy practices.',

  regionEurope: 'Europe',
  regionNorthAmerica: 'North America',
  regionLatam: 'Latin America',
  regionMea: 'Middle East & Africa',
  regionApac: 'Asia Pacific',
  regionCis: 'CIS / Russia',
  regionOther: 'Other region',

  submit: 'Submit',
  submitting: 'Submitting…',
  submitError:
    'Could not send your request. Please try again in a few seconds.',
  back: 'Back home',

  successTitle: 'Thank you!',
  successBody:
    "We've received your demo request and will get back to you shortly.",
  successBack: 'Back home',

  required: 'This field is required',
  invalidEmail: 'Enter a valid work email',
  invalidPhone: 'Enter a valid phone number',
}
